import useHasPermissionUser from "@/composables/useHasPermissionUser";
import { RouteRecordRaw } from "vue-router";
import EditPage from "../EditPage.vue";
import IndexPage from "../IndexPage.vue";

export default {
  path: "chain",
  children: [
    {
      path: "",
      name: "hotel.chain",
      component: IndexPage,
    },
    {
      path: ":id",
      name: "hotel.chain.edit",
      component: EditPage,
    },
  ],
} as RouteRecordRaw;
